import moment from 'moment'

import { IActivityMetaData } from '../../../App/store/features/activity/interface/IActivityState'
import { ICalendarState } from '../../store/calendarSlice'
import { IAppointment } from '../../types'
import { IEvent, IIconOption } from '../types/IEvent'
import { appointmentIconCheck } from '../utils/eventIconCheck'

export const calendarToEventsTransformer = (
  calendarData: ICalendarState['eventsByDay'],
  activityMetaData: {
    [key: number]: IActivityMetaData
  },
  activeDateKeys: string[],
  inActivePersonIds: number[],
): IEvent[] => {
  const events: IEvent[] = []
  Object.keys(calendarData).forEach((dateKey: string) => {
    const startOfDay = moment(dateKey).startOf('day')
    const endOfDay = moment(dateKey).endOf('day')
    // APPOINTMENT to Event
    calendarData[dateKey].appointments.forEach((appointment: IAppointment) => {
      appointment.appointmentActivity.forEach(appointmentActivity => {
        if (inActivePersonIds.includes(appointmentActivity.personId)) {
          return
        }
        if (
          !activeDateKeys.includes(dateKey) ||
          !(
            appointmentActivity.endsAt.isAfter(startOfDay) &&
            appointmentActivity.startsAt.isBefore(endOfDay)
          )
        ) {
          return
        }
        const icons: IIconOption = appointmentIconCheck(
          appointment,
          appointmentActivity,
        )
        const metadata = activityMetaData[appointmentActivity.activityId] || {
          name: 'Deleted',
          color: '#333333',
        }
        const specialStartCheck = appointmentActivity.startsAt.isBefore(dateKey)
          ? moment(dateKey).startOf('day')
          : moment(appointmentActivity.startsAt)
        events.push({
          type: 'appointment',
          id: `${appointment.uuid}_${appointmentActivity.id}`,
          groupId: `${appointment.appointmentId}_appointment`,
          startsAt: specialStartCheck,
          endsAt: moment(appointmentActivity.endsAt),
          personId: appointmentActivity.personId,
          title: `${appointment.customer.firstName} ${appointment.customer.lastName}`,
          subTitle: metadata.name,
          text: appointment.appointmentNotes || '',
          eventColor: metadata.color,
          icons,
          eventUuid: appointmentActivity.appointmentActivityUuid,
        })
      })
    })
    // BLOCK to Event
    calendarData[dateKey].blocks.forEach(block => {
      events.push({
        type: 'block',
        id: `${block.uuid}_${block.id}`,
        groupId: `${block.id}_block`,
        startsAt: moment(block.startsAt),
        endsAt: moment(block.endsAt),
        personId: block.personId,
        title: block.name,
        subTitle: '',
        text: block.notes || '',
        eventColor: block.color,
        icons: { left: [], right: [] },
        eventUuid: block.uuid,
      })
    })
  })
  return events
}
